import React from "react";
import { cva } from "class-variance-authority";

import { cn } from "utils/cn";

const badgeVariants = cva("bg- rounded px-2.5 py-0.5 text-xs font-medium", {
  variants: {
    type: {
      success: "bg-green-100 text-green-800",
      danger: "bg-red-100 text-red-800",
      default: "bg-neutral-100 text-neutral-800",
    },
  },
  defaultVariants: {
    type: "default",
  },
});

const Badge = ({ type, className, children }) => {
  return <span className={cn(badgeVariants({ type }), className)}>{children}</span>;
};

Badge.displayName = "Badge";

export { Badge };
